import numeral from "numeral";

export const PICPICK_LATEST_VERSION = "7.3.6";
export const PICPICK_LATEST_KO_VERSION = "7.3.6";
export const PICPICK_BETA_VERSION = "8.0.0-beta5";

export const PICPICK_DISCOUNT = true;
export const PICPICK_YEARLY = true;
export const PICPICK_SAVE_COST = true;

export const IS_BLACKFRIDAY = false;

export const DOWNLOAD_FREE_CDN = `https://download.picpick.app/${PICPICK_LATEST_VERSION}/picpick_inst.exe`;
export const DOWNLOAD_PRO_CDN = `https://download.picpick.app/${PICPICK_LATEST_VERSION}/picpick_inst_pro.exe`;
export const DOWNLOAD_PORTABLE_CDN = `https://download.picpick.app/${PICPICK_LATEST_VERSION}/picpick_portable.zip`;
export const DOWNLOAD_KR_CDN = `https://download.picpick.app/${PICPICK_LATEST_KO_VERSION}/picpick_inst_kr.exe`;

export const DOWNLOAD_FREE_AWS = `https://www.picpick.org/releases/${PICPICK_LATEST_VERSION}/picpick_inst.exe`;
export const DOWNLOAD_PRO_AWS = `https://www.picpick.org/releases/${PICPICK_LATEST_VERSION}/picpick_inst_pro.exe`;
export const DOWNLOAD_PORTABLE_AWS = `https://www.picpick.org/releases/${PICPICK_LATEST_VERSION}/picpick_portable.zip`;
export const DOWNLOAD_KR_AWS = `https://www.picpick.org/releases/${PICPICK_LATEST_KO_VERSION}/picpick_inst_kr.exe`;

export const DOWNLOAD_BETA_CDN = `https://download.picpick.app/${PICPICK_BETA_VERSION}/picpick_inst_x64.exe`;
export const DOWNLOAD_BETA_KR_CDN = `https://download.picpick.app/${PICPICK_BETA_VERSION}/picpick_inst_x64_kr.exe`;

export const isDevelopmentMode = () => {
  const { NODE_ENV } = process.env;
  return NODE_ENV && NODE_ENV === "development";
};

export const categoryOptions = [
  {
    key: "sales",
    text: "Sales / Pricing / Quotes",
    value: "sales",
  },
  {
    key: "license",
    text: "License Issues",
    value: "license",
  },
  {
    key: "request",
    text: "Requests / Bugs",
    value: "request",
  },
  {
    key: "other",
    text: "Other",
    value: "other",
  },
];

export const categoryOptionsKo = [
  {
    key: "request",
    text: "요청 및 건의",
    value: "request",
  },
  {
    key: "sales",
    text: "제휴 문의",
    value: "sales",
  },
  {
    key: "other",
    text: "기타",
    value: "other",
  },
];

export const osOptions = [
  {
    key: "windows11",
    text: "Windows 11",
    value: "windows11",
  },
  {
    key: "windows10",
    text: "Windows 10",
    value: "windows10",
  },
  {
    key: "windows8",
    text: "Windows 8 / 8.1",
    value: "windows8",
  },
  {
    key: "windows7",
    text: "Windows 7",
    value: "windows7",
  },
  {
    key: "windowsold",
    text: "Windows Vista / XP",
    value: "windowsold",
  },
  {
    key: "others",
    text: "Others (Please specify on the detail)",
    value: "others",
  },
];

export const licenseOptions = [
  {
    path: "picpick-subscription",
    key: "subscription",
    text: "PicPick Pro Plan",
    value: "subscription",
  },
  {
    path: "picpick-lifetime",
    key: "lifetime",
    text: "PicPick Pro Lifetime",
    value: "lifetime",
  },
  {
    path: "picpick-enterprise-lifetime",
    key: "enterprise",
    text: "PicPick Enterprise Lifetime",
    value: "enterprise",
  },
];

export const getLicenseName = (license) => {
  let licenseName = "PicPick Pro";
  try {
    licenseName = licenseOptions.find((item) => item.key === license).text;
  } catch (e) {
    //
  }
  return licenseName;
};

const volumeSubscriptionPrice = (total) => {
  switch (true) {
    case total <= 1:
      return 2.5;
    case total < 5:
      return 2.25;
    case total < 10:
      return 2.0;
    case total < 25:
      return 1.75;
    case total < 100:
      return 1.5;
    default:
      return 1.25;
  }
};

const volumeDiscountedSubscriptionPrice = (total) => {
  switch (true) {
    case total <= 1:
      return 2.0;
    case total < 5:
      return 1.8;
    case total < 10:
      return 1.6;
    case total < 25:
      return 1.4;
    case total < 100:
      return 1.2;
    default:
      return 1;
  }
};

const volumeLifetimePrice = (total) => {
  switch (true) {
    case total <= 1:
      return 60;
    case total < 5:
      return 55;
    case total < 10:
      return 50;
    case total < 25:
      return 45;
    case total < 100:
      return 40;
    default:
      return 35;
  }
};

const volumeDiscountedLifetimePrice = (total) => {
  switch (true) {
    case total <= 1:
      return 55;
    case total < 5:
      return 50;
    case total < 10:
      return 45;
    case total < 25:
      return 40;
    case total < 100:
      return 35;
    default:
      return 30;
  }
};

export const formatPrice = (price) => {
  return numeral(price).format("$ 0,0[.]00");
};

export const formatTablePrice = (price) => {
  return numeral(price).format("$ 0,0.00");
};

export const getPrice = (quantity, license, discount, yearly = true) => {
  let price = 0;

  if (discount) {
    if (license === "lifetime") {
      price = quantity * volumeDiscountedLifetimePrice(quantity);
    } else if (license === "enterprise") {
      price = 2400;
    } else {
      price = quantity * volumeDiscountedSubscriptionPrice(quantity);
      if (yearly) {
        price *= 12;
      }
    }
    return price;
  }

  if (license === "lifetime") {
    price = quantity * volumeLifetimePrice(quantity);
  } else if (license === "enterprise") {
    price = 3000;
  } else {
    price = quantity * volumeSubscriptionPrice(quantity);
    if (yearly) {
      price *= 12;
    }
  }
  return price;
};

export const getUnitPrice = (quantity, license, discount, yearly = true) => {
  let price = 0;

  if (discount) {
    if (license === "lifetime") {
      price = volumeDiscountedLifetimePrice(quantity);
    } else if (license === "enterprise") {
      price = 2400;
    } else {
      price = volumeDiscountedSubscriptionPrice(quantity);
      if (yearly) {
        price *= 12;
      }
    }
    return price;
  }

  if (license === "lifetime") {
    price = volumeLifetimePrice(quantity);
  } else if (license === "enterprise") {
    price = 3000;
  } else {
    price = volumeSubscriptionPrice(quantity);
    if (yearly) {
      price *= 12;
    }
  }
  return price;
};
